import {
  IAccommodationReservationParams,
  IAccommodationSingleReservationParams,
} from "Bands/types";
import { merge, range } from "lodash-es";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

interface IJSONAPIAccommodationReservation {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIAccommodationReservationCollection {
  [IDataKeys.eventAccommodationReservation]: IJSONAPIAccommodationReservation;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventAccommodationReservationService {
  static createAccommodationReservation = (
    data: IAccommodationReservationParams
  ): Promise<IJSONAPIAccommodationReservationCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATIONS_ADD_PEOPLE,
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.CREATE_EVENT_ACCOMMODATION_RESERVATION
        );
        return reject(error);
      }
    });

  static deleteAccommodationReservation = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATION(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.DELETE_EVENT_ACCOMMODATION_RESERVATION
        );
        return reject(error);
      }
    });

  static editAccommodationReservation = ({
    id,
    data,
  }: {
    id: string;
    data: IAccommodationSingleReservationParams;
  }): Promise<IJSONAPIAccommodationReservation> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATION(id),
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.PATCH_EVENT_ACCOMMODATION_RESERVATION
        );
        return reject(error);
      }
    });

  static getEventAccommodationReservations = (
    queryParams?: {
      [key: string]: any;
    },
    isRecursive?: boolean
  ): Promise<IJSONAPIAccommodationReservationCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        let reservations = await APIService.get({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATIONS,
          data: queryParams,
        });

        if (!isRecursive) {
          resolve(reservations as IJSONAPIAccommodationReservationCollection);
          return;
        }

        // get all reservations until last page
        const { currentPage, totalPages } = reservations.pagination || {};
        const toFetchPages = range(currentPage + 1, totalPages + 1);

        for (const page of toFetchPages) {
          const newReservation = await APIService.get({
            path: API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATIONS,
            data: {
              ...queryParams,
              page,
            },
          });

          reservations = merge({}, reservations, newReservation);
        }

        reservations.pagination.currentPage = 1 as any;

        resolve(reservations as IJSONAPIAccommodationReservationCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_ACCOMMODATION_RESERVATIONS);
        return reject(error);
      }
    });
}
